import env from "./.env";
const host = window.location.hostname;
let baseApiUrl: string;

if (host === "lemu.co.ke" || host === "localhost" || host === "127.0.0.1") {
  baseApiUrl = "https://mednocapi.lemu.co.ke"; //dev url
  // baseApiUrl = "https://demoapi.falconpad.com"; //demo url
} else {
  const tenant = host.split(".")[0];
  baseApiUrl = `https://${tenant}api.lemu.co.ke`;
}

export const environment = {
  analytics: false,
  production: true,
  defaultauth: "fakebackend",
  version: env.version,
  baseApiUrl: baseApiUrl,
  //baseApiUrl: "http://localhost:9004", //dev url
  apiProvider: "/mednoc/api",
  apiVersion: "/v1",
  serverUrl: "",
  defaultLanguage: "en-US",
  supportedLanguages: ["en-US", "fr-FR"],
  GOOGLE_MAPS_API_KEY: "AIzaSyB67XHD9NHbdx1wcL4olPNJkOipDDESocU",

  paymentUrl: "https://sandbox.web.squarecdn.com/v1/square.js",
  // paymentLocationId: "LV66YV2GJBA3N",
  // paymentApplicationId: "sandbox-sq0idb-lb1kZOfnrl5DQNrPnOW-FA",
  paymentLocationId: "LA00FYC0JK4J1",
  paymentApplicationId: "sandbox-sq0idb-7biKBoScqFe9YvVCmd2HGQ",

  stripePublishableKey:
      "pk_test_51Sosf1BZxvv6mqxOV1f0BXsSGkELUP4W6XGwW73k8USoROMdRe4cMv9in7FrxLDEq4n92HL6OlpYQU9m79ValleA00qiW4tTLS",
};
